import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles, Check } from "lucide-react";

/** Customer launch offer: first 5 completed cleans carry no £1.99 service charge. */
export const ServiceFeeOffer = ({ className = "" }) => {
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    api.get("/offers/service-fee").then((r) => setOffer(r.data)).catch(() => setOffer(null));
  }, []);

  if (!offer) return null;

  // All 5 used — keep the customer informed rather than silently hiding the offer.
  if (!offer.active) {
    return (
      <div className={`rounded-2xl border border-border bg-secondary/40 p-5 flex items-start gap-4 ${className}`}
        data-testid="service-fee-offer-banner">
        <div className="h-10 w-10 rounded-xl bg-primary/5 flex items-center justify-center shrink-0">
          <Check className="h-5 w-5 text-muted-foreground" />
        </div>
        <div className="min-w-0">
          <p className="font-display font-semibold" data-testid="offer-headline">
            You've used all {offer.total} service-charge-free cleans
          </p>
          <p className="text-sm text-muted-foreground mt-1" data-testid="offer-progress">
            The standard £{offer.service_fee.toFixed(2)} My Clean Connect™ service charge now applies
            to new bookings.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-2xl border border-accent/30 bg-accent/5 p-5 flex items-start gap-4 ${className}`}
      data-testid="service-fee-offer-banner">
      <div className="h-10 w-10 rounded-xl bg-accent/15 flex items-center justify-center shrink-0">
        <Sparkles className="h-5 w-5 text-accent" />
      </div>
      <div className="min-w-0">
        <p className="font-display font-semibold" data-testid="offer-headline">{offer.headline}</p>
        <p className="text-sm font-medium mt-1" data-testid="offer-progress">{offer.progress}</p>
        <div className="mt-1.5 flex items-center gap-1.5" data-testid="offer-pips">
          {Array.from({ length: offer.total }).map((_, i) => (
            <span key={i}
              className={`h-2 flex-1 max-w-10 rounded-full ${i < offer.remaining ? "bg-accent" : "bg-accent/20"}`}
              data-testid={`offer-pip-${i + 1}-${i < offer.remaining ? "left" : "used"}`} />
          ))}
        </div>
        <p className="text-sm text-muted-foreground mt-2" data-testid="offer-terms">
          No time limit — it stays on your account until all {offer.total} are used. Only completed
          cleans count, so cancelled, refunded or no-show bookings don't use one up.
          {offer.held_note ? ` (${offer.held_note}.)` : ""}
        </p>
      </div>
    </div>
  );
};

export default ServiceFeeOffer;
